"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "bagno-a-ripoli": {
    "41c7e711": [{
      "hkey": "e13cbc2b",
      "slug": "rimaggio-candeli",
      "name": "Rimaggio-Candeli",
      "primary": true,
      "skipSearch": false
    }],
    "candeli": [{
      "hkey": "e13cbc2b",
      "slug": "rimaggio-candeli",
      "name": "Rimaggio-Candeli",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "7277a0b2": [{
      "hkey": "8d2b5969",
      "slug": "grassina-ponte-a-ema",
      "name": "Grassina-Ponte a Ema",
      "primary": true,
      "skipSearch": false
    }],
    "grassina": [{
      "hkey": "8d2b5969",
      "slug": "grassina-ponte-a-ema",
      "name": "Grassina-Ponte a Ema",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "00969cad": [{
      "hkey": "8f12ce6d",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "meoste": [{
      "hkey": "8f12ce6d",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "5aef7fc4": [{
      "hkey": "8d2b5969",
      "slug": "grassina-ponte-a-ema",
      "name": "Grassina-Ponte a Ema",
      "primary": true,
      "skipSearch": false
    }],
    "ponte-a-ema": [{
      "hkey": "8d2b5969",
      "slug": "grassina-ponte-a-ema",
      "name": "Grassina-Ponte a Ema",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "b5e70edb": [{
      "hkey": "8d2b5969",
      "slug": "grassina-ponte-a-ema",
      "name": "Grassina-Ponte a Ema",
      "primary": true,
      "skipSearch": false
    }],
    "ponte-a-niccheri": [{
      "hkey": "8d2b5969",
      "slug": "grassina-ponte-a-ema",
      "name": "Grassina-Ponte a Ema",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "a428edfd": [{
      "hkey": "e13cbc2b",
      "slug": "rimaggio-candeli",
      "name": "Rimaggio-Candeli",
      "primary": true,
      "skipSearch": false
    }],
    "rimaggio": [{
      "hkey": "e13cbc2b",
      "slug": "rimaggio-candeli",
      "name": "Rimaggio-Candeli",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;